module.exports = __webpack_public_path__ + "img/kali-linux.93c02c2d.png";